import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconClose from 'components/icons/iconClose';
import IconSimpleArrowLeft from 'components/icons/iconSimpleArrowLeft';
const MobileModalCloseIcon = t0 => {
  const $ = _c(10);
  const {
    color: t1,
    icon: t2,
    variant
  } = t0;
  const color = t1 === undefined ? "content" : t1;
  const icon = t2 === undefined ? "close" : t2;
  if (icon === "arrow") {
    const t3 = color === "content";
    const t4 = color === "white";
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
      t5 = classNames("[&_path]:transition-all [&_path]:duration-200 [&_path]:ease-in-out", {
        "[&_path]:stroke-[#424242]": t3,
        "[&_path]:stroke-[#fff]": t4
      });
      $[0] = t3;
      $[1] = t4;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    let t6;
    if ($[3] !== t5) {
      t6 = <IconSimpleArrowLeft className={t5} height="18" width="14" />;
      $[3] = t5;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    return t6;
  }
  const t3 = color === "content" && variant !== "ModularAddProducts";
  const t4 = color === "white" || variant === "ModularAddProducts";
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = classNames("[&_path]:transition-all [&_path]:duration-200 [&_path]:ease-in-out", {
      "[&_path]:fill-gray": t3,
      "[&_path]:fill-white": t4
    });
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <IconClose className={t5} height="14" width="14" />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
MobileModalCloseIcon.propTypes = {
  icon: PropTypes.oneOf(['close', 'close-white', 'arrow']),
  color: PropTypes.oneOf(['content', 'white']),
  variant: PropTypes.oneOf(['ModularAddProducts'])
};
export default MobileModalCloseIcon;